<template>
  <ManuelContent hero src="/docs/manuel-utilisateur.md" />
</template>

<script>
import ManuelContent from '@/components/ManuelContent.vue'

export default {
  name: 'ManuelView',
  components: { ManuelContent },
}
</script>
